/**
 * Created by Danila Krupnov on 6/5/25
 */

const BackgroundsAltWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        options = this.options = options || {};
        this._super({
            title: undefined,
            noTitle: true,
            content: this.createContent(options.moveNext),
            name: "BackgroundsWindow",
            notCloseByTouchInShadow: true,
            closeButtonDelay: options.moveNext ? 4 : true,
            noBackground: true,
            styles: cleverapps.styles.BackgroundsAltWindow
        });

        if (this.windowTitle) {
            this.windowTitle.getMaxTextWidth = function () {
                const sceneWidth = cleverapps.resolution.getSceneSize().width / this.scale;

                return sceneWidth - 3 * Math.max(this.type.text.scenePaddingX, this.type.background.padding.x);
            };
        }

        if (options.forceMinimal) {
            this.addForceMinimal();
        }
    },

    onShow: function () {
        this._super();

        if (this.options.moveNext) {
            if (cleverapps.focusManager.isFocused()) {
                cleverapps.focusManager.setEventNodes([]);
            }
            this.changeCurrent();
        }
    },

    changeCurrent: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const current = location.getStage() - 1;
        const next = current >= this.scroll.items.length - 2 ? false : location.getStage();

        const currentItem = this.scroll.items[current];
        const nextItem = next !== false && this.scroll.items[next];

        new ActionPlayer([
            (f) => currentItem.fillProgressBar(f),
            (f) => currentItem.hidePresentAndFlyRewards(f),
            (f) => {
                currentItem.playComplete();
                if (nextItem) {
                    this.onScrollToNext();
                    this.scroll.scroll.scrollTo(this.scroll.items[next], 1.5);
                    this.runAction(new cc.Sequence(new cc.DelayTime(1.5), new cc.CallFunc(f))).setFinalize(f);
                } else {
                    f();
                }
            },
            (f) => (nextItem ? nextItem.openLock(f) : f()),
            (f) => this.onChanged(f)
        ]).play(this.close.bind(this));
    },

    onScrollToNext: function () {
    },

    onChanged: function (f) {
        this.particlesAnimation();
        f();
    },

    addForceMinimal: function () {
        const dialogue = this.dialogue = new MinimalDialogue({
            delay: 0,
            text: Messages.get("Simple.Force")
        });
        this.addChild(dialogue);
    },

    createContent: function (moveNext) {
        var scroll = this.scroll = new BackgroundScroller(moveNext);
        this.scroll.setAnchorPoint(0.5, 0.5);
        this.addChild(this.scroll);

        let width = scroll.items[0].width * BackgroundScroller.PAGES_COUNT;
        let height = scroll.items[0].height;
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            width = scroll.items[0].width;
            height = scroll.items[0].height * BackgroundScroller.PAGES_COUNT;
        }

        const node = new cc.Node();
        node.setContentSize(width, height);
        node.setAnchorPoint(0.5, 0.5);
        return node;
    },

    listBundles: function () {
        return ["backgrounds_window", "simple_stickers"];
    },

    listLazyUrls: function (options) {
        options = options || {};

        const stage = cleverapps.meta.getSelectedLocation().getStage() - (options.moveNext ? 1 : 0);

        return [stage - 1, stage, stage + 1]
            .map((index) => bundles.backgrounds_window.urls[`background_${index}`])
            .filter(Boolean);
    },

    particlesAnimation: function () {
        const particles = new cleverapps.Spine(bundles.simple.jsons.background_particles_json);
        const scene = cleverapps.Scenes.GetRunningScene();
        const animation = particles.hasAnimation("particle_bg") ? "particle_bg" : "animation";
        particles.setPosition(scene.width / 2, scene.height / 2);
        scene.addChild(particles);
        particles.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(), { keepScale: true });
        particles.setAnimation(0, animation, false);
        particles.setCompleteListenerRemove();
    },

    closeAnimation: function (f) {
        this.scroll.items.forEach((item) => item.hideAnimation());

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.CallFunc(f)
        ));

        this._super();
    }
});

BackgroundsWindow = BackgroundsAltWindow;

cleverapps.styles.BackgroundsAltWindow = {
    item: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    }
};